import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

export const CircularProgressBar = ({ value = 0, maxValue = 100, text, size = 56 }) => {
  return (
    <div style={{ width: size, height: size }}>
      <CircularProgressbar value={value} maxValue={maxValue} text={text} />
    </div>
  )
}
